// JSON updated by Republic
const FLAT_BALLOT_URL =
  'https://s3.us-east-1.amazonaws.com/sos-test-2.texastribune.org/2026_general/ballot_page/results_FLAT_for_ballot.json';

export {
  FLAT_BALLOT_URL
};
